<template>
  <div class="home">
    <el-container>
      <el-aside style="max-width: 240px; width: auto">
        <Aside />
      </el-aside>
      <el-container>
        <el-header height="72px">

          <Head />
        </el-header>
        <el-main> <router-view class="routerView" /></el-main>
      </el-container>
    </el-container>
    <!-- 往上 -->
    <el-backtop :bottom="70" target=".el-main" :right="10">
      <div class="up">
        <i class="el-icon-arrow-up"></i>
      </div>
    </el-backtop>
    <!-- 往下 -->
    <div class="bottom" @click="toBottom">
      <i class="el-icon-arrow-down"></i>
    </div>
  </div>
</template>
<script>
import Head from "@/components/userHome/Head.vue";
import Aside from "@/components/userHome/aside.vue";

import { mapState } from "vuex";
export default {
  metaInfo() {
    return {
      title: '客户管理',
    };
  },
  data() {
    return {
      tableData: [],
    };
  },
  components: {
    Head,
    Aside,
  },
  created() {
    let query = this.$route.query
    // if (query.encryption !== this.$md5(query.userID + '')) {
    //   return this.$alert('不得直接修改链接进入客户详情，请从正确位置查看客户详情', '警告', {
    //     confirmButtonText: '确定',
    //     center: true,
    //     callback: action => {
    //       window.open("about:blank", "_top").close();
    //     }
    //   });
    // }

    this.$store.commit("setUserID", query.userID);
  },
  methods: {
    // 到底部
    toBottom() {
      var osTop = 0
      let timer = setInterval(function () {
        var elMain = document.querySelector('.el-main')
        var elMainHeight = elMain.scrollHeight
        let ispeed = Math.floor(elMainHeight / 5);
        osTop += ispeed
        elMain.scrollTo(0, osTop)
        if (osTop >= elMainHeight) {
          clearInterval(timer);
        }
      }, 50);
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin";

.up {
  height: 100%;
  width: 100%;
  background-color: #b4272d;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 50%;
}

.bottom {
  height: 40px;
  width: 40px;
  background-color: #b4272d;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: fixed;
  right: 10px;
  bottom: 20px;
  cursor: pointer;
  z-index: 9999;

  i {
    font-size: 20px;
    color: #fff;
  }
}

/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

// /deep/.is-checked {
//   .el-checkbox__inner {
//     background-color: #32323c;
//   }
// }
.home {
  @include wh(100%, calc(100%));
  margin: 0 auto;
  position: relative;
  min-width: 1700px;

  .el-button {
    position: absolute;
    top: 10px;
    right: 100px;
    z-index: 999;
  }

  header {
    background-color: #fff;
    height: 60px;
    padding: 20px 0 0 30px;
    box-sizing: border-box;
  }

  /deep/ .el-tabs__nav-wrap::after {
    display: none !important;
  }

  .el-container {
    height: 100%;

    overflow: hidden;
    padding: 0;

    .el-header {
      color: #333;
      padding: 0;
    }

    .el-aside {
      height: 100%;
      background-color: #32323c;
      color: #333;
      text-align: center;
    }

    .el-main {
      height: 100%;
      background-color: $el-main-bgc;
      color: #333;
      padding: 0 !important;

      .routerView {
        background: #fff;
        min-height: calc(100vh - 72px);
        //height: 100%;
        padding: 24px;
        box-sizing: border-box;
      }
    }
  }
}
</style>